module.exports = __webpack_public_path__ + "img/60.3167b9de.jpg";